import { useLocation, useNavigate } from 'react-router-dom';
import { Landmark, ArrowLeftRight, Plus, Calendar, Target } from 'lucide-react';

const navItems = [
  { path: '/contas', label: 'Contas', icon: Landmark },
  { path: '/transacoes', label: 'Transações', icon: ArrowLeftRight },
  { path: '__fab__', label: '', icon: Plus },
  { path: '/agenda', label: 'Agenda', icon: Calendar },
  { path: '/metas', label: 'Metas', icon: Target },
];

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleFabClick = () => {
    window.dispatchEvent(new CustomEvent('open-transaction-form'));
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-background border-t border-border">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          if (item.path === '__fab__') {
            return (
              <button
                key="fab"
                onClick={handleFabClick}
                className="flex items-center justify-center w-14 h-14 -translate-y-4 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 border-4 border-background active:scale-95 transition-transform"
                aria-label="Nova transação"
              >
                <Plus size={28} strokeWidth={2.5} />
              </button>
            );
          }

          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 min-w-[3rem] py-1 transition-colors ${
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground'
              }`}
            >
              <Icon size={22} />
              <span className="text-[10px] font-medium leading-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
